import api from '@utils/api';

export const deleteUser = async (id) => {
    return new Promise(async (resolve, reject) => {
        try {
            const {data} = await api.delete(`/user/${id}`);
            resolve(data.data);
        } catch (error) {
            reject(error.response.data);
        }
    });
};

export const getUsers = async () => {
    try {
        const response = await api.get('/users');
        return response.data.data;
    } catch (error) {
        throw error.response.data;
    }
};

export const getUserById = async (id) => {
    try {
        const response = await api.get(`/user/${id}`);
        return response.data.data;
    } catch (error) {
        throw error.response.data;
    }
};

export const createUser = async (userData) => {
    return new Promise(async (resolve, reject) => {
        try {
            const response = await api.post("/users", userData);
            resolve(response.data);
        } catch (error) {
            reject(error.response.data);
        }
    });
};
export const updateUser = async (id, userData) => {
    return new Promise(async (resolve, reject) => {
        try {
            const response = await api.put(`/user/${id}`, userData)
            resolve(response.data);
        } catch (error) {
            reject(error.response.data);
        }
    });
};

export const syncUserAbilities = async (id, abilityData) => {
    try {
        const response = await api.post(`/user/${id}/sync`, abilityData);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
};

/**
 * @param {string} user
 * @param {number[]} companies
 *
 * @returns {Promise<*>}
 */
export const syncCompanies = async (user, companies) => (
  api.post(`user/${user}/sync-companies`, {companies})
);

export const syncUserModuleGroups = async (userId, moduleGroups) => {
    const response = await api.put(`/user/${userId}/module-groups`, { module_groups: moduleGroups });
    return response.data?.data || response.data;
};

export const getLatestCompany = () => (localStorage.getItem('latestCompanyId'));

export const setLatestCompany = (id) => (localStorage.setItem('latestCompanyId', id));

export const getAvailableMobileModules = async () => {
    try {
        const response = await api.get('/user/mobile-modules/available');
        return response.data.data;
    } catch (error) {
        throw error.response.data;
    }
};

export const getUserMobileModules = async () => {
    try {
        const response = await api.get('/user/mobile-modules');
        return response.data.data;
    } catch (error) {
        throw error.response.data;
    }
};

export const updateUserMobileModules = async (modules) => {
    try {
        await api.put('/user/mobile-modules', { modules });
    } catch (error) {
        throw error.response.data;
    }
};

export const getDesktopShortcuts = async () => {
    const response = await api.get('/user/desktop-shortcuts');
    return response.data.data;
};

export const updateDesktopShortcuts = async (screens) => {
    await api.put('/user/desktop-shortcuts', { screens });
};
